(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__6073__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["name", "size", "color", "additionalCSS"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Icon = function Icon(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "0.75rem" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "" : _ref$color,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS,
      additionalAttributes = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    className: "".concat(color, " ").concat(additionalCSS),
    style: {
      width: size,
      height: size
    }
  }, additionalAttributes), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("use", {
    xlinkHref: "#sprite-".concat(name)
  }));
};

Icon.propTypes = {
  name: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 6073:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ ContactFooter)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/url-base.js
var DEFAULT_URL_BASE = "";

var absUrl = function absUrl(path) {
  var urlBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_URL_BASE;
  return "".concat(urlBase).concat(path);
};

/* harmony default export */ const url_base = (absUrl);
;// CONCATENATED MODULE: ./src/core/dom-query.js
var queryId = function queryId(val) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelector("[data-id=".concat(val, "]"));
};
var queryIdAll = function queryIdAll(val) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return root.querySelectorAll("[data-id=".concat(val, "]"));
};
;// CONCATENATED MODULE: ./src/core/hubspot-chat-toggle.js

/*
    A method to enable/disable a CTA that
    is used to open the HubSpot chat widget

    If the Chat widget is unavailable this script
    will apply a disabled property and change
    the text on the button, to warn the user.

    Params:
    - dataId        the parent container data-id

*/

function enableBtn(el, text) {
  el.disabled = false;
  el.innerText = text;
}

function disableBtn(el, text) {
  el.disabled = true;
  el.innerText = text;
}

var WAIT_BETWEEN_RETRIES_MS = 100;
var MAX_RETRY_COUNT = 30;
function toggleChatWidget() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dataId = params.dataId;
  var container = queryId(dataId);
  var chatButton = queryId("open-chat-widget", container);
  var textEnabled = chatButton.dataset.enabledLabel;
  var textDisabled = chatButton.dataset.disabledLabel;
  if (!dataId || !container) return;
  var trigger = queryId("open-chat-widget", container);
  var clickHandler;

  var waitForScript = function waitForScript(delay) {
    var _window, _window$HubSpotConver;

    var widget = (_window = window) === null || _window === void 0 ? void 0 : (_window$HubSpotConver = _window.HubSpotConversations) === null || _window$HubSpotConver === void 0 ? void 0 : _window$HubSpotConver.widget; // If the chat is set to be hidden out of hours this will return null

    var iframe = document.querySelector("#hubspot-messages-iframe-container");

    clickHandler = function clickHandler(e) {
      e.preventDefault();
      widget.open();
    };

    if (widget && iframe) {
      trigger.addEventListener("click", clickHandler);
      enableBtn(trigger, textEnabled);
    } else if (--MAX_RETRY_COUNT) {
      setTimeout(function () {
        return waitForScript(WAIT_BETWEEN_RETRIES_MS);
      }, delay);
    }
  };

  disableBtn(trigger, textDisabled);
  waitForScript(0);
  return function () {
    disableBtn(trigger, textDisabled);
    trigger.removeEventListener("click", clickHandler);
  };
}
;// CONCATENATED MODULE: ./src/core/ContactFooter/component.js


/* harmony default export */ const ContactFooter_component = (function () {
  return toggleChatWidget({
    dataId: "contact-footer"
  });
});
;// CONCATENATED MODULE: ./src/core/ContactFooter/component.jsx





function ContactFooter(_ref) {
  var urlBase = _ref.urlBase;
  (0,external_commonjs_react_commonjs2_react_.useEffect)(function () {
    return ContactFooter_component();
  }, []);

  var absUrl = function absUrl(path) {
    return url_base(path, urlBase);
  };

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-contact-footer font-sans antialiased",
    "data-id": "contact-footer"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "w-full bp-lg max-w-screen-xl mx-auto py-64 grid grid-cols-1 md:grid-cols-3 ui-grid-gap ui-grid-px"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-contact-footer-box"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-display-live-chat",
    size: "3rem",
    additionalCSS: "block mb-16"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-text-h3 mb-24"
  }, "Live Chat"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p1"
  }, "Reach out team of experts over chat powered by Ably.")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("button", {
    type: "button",
    className: "ui-btn-secondary self-start mt-16",
    disabled: true,
    "data-id": "open-chat-widget",
    "data-enabled-label": "Start a live chat",
    "data-disabled-label": "Live chat unavailable"
  }, "Live chat unavailable")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-contact-footer-box"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-display-call-mobile",
    size: "3rem",
    additionalCSS: "block mb-16"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-text-h3 mb-24"
  }, "Call us"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("span", {
    className: "block"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("strong", {
    className: "font-bold"
  }, "+1 877 434 5287"), " (USA, toll free)"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("span", {
    className: "block"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("strong", {
    className: "font-bold"
  }, "+44 20 3318 4689"), " (UK)")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-contact-footer-box"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-display-tech-account-comms",
    size: "3rem",
    additionalCSS: "block mb-16"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "ui-text-h3 mb-24"
  }, "Technical and account support"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p1"
  }, "We're standing by to help with any questions or code.")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "ui-btn-secondary self-start p-btn mt-16",
    href: absUrl("/support")
  }, "Get support now"))));
}
ContactFooter.propTypes = {
  urlBase: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});